// extracted by mini-css-extract-plugin
export default {"FilterPillsBar":"FilterPillsBar","FilterPill":"FilterPill","FilterPillsBar--spacer":"FilterPillsBar--spacer"};